import { render, staticRenderFns } from "./bigDetailTable.vue?vue&type=template&id=2faa6704&scoped=true"
import script from "./bigDetailTable.vue?vue&type=script&lang=js"
export * from "./bigDetailTable.vue?vue&type=script&lang=js"
import style0 from "./bigDetailTable.vue?vue&type=style&index=0&id=2faa6704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa6704",
  null
  
)

export default component.exports